import { api } from '@/services/api';
import type { LearningPath } from '@/services/types';

export async function getLearningPath() {
  const response = await api.get<LearningPath>('/learning/path');
  return response.data;
}
